import { ActionWithNotification, IMultipleDelayedActionService } from './multiple-delayed-action.interface';
import { injectable } from 'inversify';

@injectable()
export class MultipleDelayedActionService implements IMultipleDelayedActionService {
    private rules: Array<ActionWithNotification<string>>;
    private readonly inProgress = new Map<string, number>();

    init(rules: Array<ActionWithNotification<string>>): void {
        this.rules = rules;
    }

    add = (items: Array<string>): void => {
        items?.forEach(item => {
            if (!this.inProgress.has(item)) {
                this.start(item);
            }
        });
    };

    remove = (items: Array<string>): void => {
        items?.forEach(item => {
            if (this.inProgress.has(item)) {
                this.stop(item);
            }
        });
    };

    flush = (): void => {
        for (const key of this.inProgress.keys()) {
            this.stop(key);
        }
        this.inProgress.clear();
    };

    private start(id: string): void {

        const actionToTake = this.rules?.find(action => action.condition(id));

        if (Boolean(actionToTake)) {

            const timerToken = window.setTimeout(() => {
                actionToTake.action(id);
                this.inProgress.delete(id);
            }, actionToTake.delay);

            this.inProgress.set(id, timerToken);
        }
    }

    private readonly stop = (id: string): void => {
        window.clearTimeout(this.inProgress.get(id));
        this.inProgress.delete(id);
    };
}
